import react, {useEffect, useState} from "react"
import { BrowserRouter, Route, Switch } from 'react-router-dom';


import { Shimmer } from 'react-shimmer'

import 'semantic-ui-css/semantic.min.css'
import './App.css';
import classplusLogo from "./resources/ClassplusLogo.png";
import guruDlogo from "./resources/guruDlogo.png";

import { teachersCard } from "./utils/tecahersCard/index";

import { Button,Grid, Popup } from 'semantic-ui-react'
import WelcomePage from "./components/welcomePage";
import DetailPage from "./components/detailsPage";
import MemoryOutput from "./components/memoryOutput";
// import CardsChain from "./components/CardsChainPage";
import Memories from "./components/Memories";

import WithCreativeURL from "./components/WithCreativeURLPage";

import StudentPage from "./components/StudentPage";
import TutorPage from "./components/TutorPage";

function App() {

const [Images, setImages] = useState([])
const [datalength,setDataLength] = useState()

const [limit,setLimit] = useState(10)
const [offset,setOffset] = useState(0)
const [hasMore,setHasMore] = useState(true)
const [Loading, setLoading] = useState(false)

const [ token, setToken ] = useState()

const [ UserType, setUserType ] = useState()

const [ creativeUrl, setcreativeUrl ] = useState()

const [imagesArray,setImagesArray] = useState()
const handleGetApi =  ()=>{
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      
      // body: JSON.stringify(body)
    };
    fetch(`https://multiverse-api.classplusapp.com/ts/teachersday/get-teacher?limit=${limit}&offset=${offset}`, requestOptions)
    .then(response => response.json())
    .then(
      data => {
            if(offset === 0) {
              setDataLength(data.data.count);
              setImages(data.data.data);
              setOffset(limit);
              if(data.data.count > data.data.data.length) {
                setHasMore(true)
              } else setHasMore(false)
            } else {
              if((Images.length+data.data.data.length >= datalength)) {
                setHasMore(false)
              } else setHasMore(true)
              setImages([...Images,...data.data.data]);
              setOffset(offset+limit);
            }
            setLoading(false)
      }
      )   
}

// useEffect(()=>{
//   console.log("jayjaychanges",limit,offset,Images,datalength,hasMore);
// },[limit,offset,Images,datalength,hasMore])
  // useEffect(() => {
  //   handleGetApi()
  // }, [])


  useEffect(() => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    let token = urlParams.get("token");
    let creativeUrl = urlParams.get("creativeUrl");

    if(creativeUrl){
      setcreativeUrl(creativeUrl)
    }

       if(token){
         console.log("get token")
         console.log(token ,"get token")
        var base64Url = (urlParams.get("token")).split('.')[1];
        var decodedValue = JSON.parse(window.atob(base64Url));
        setUserType(decodedValue.type)
       }

  const utmSource = urlParams.get("utm_source");
  const utmMedium = urlParams.get("utm_medium");
  const utmCampaign = urlParams.get("utm_campaign");

  if(token) {
    sessionStorage.setItem('token',token)
  }

  if(creativeUrl){
    sessionStorage.setItem('creativeUrl',creativeUrl)
  }

  if (utmSource || utmMedium || utmCampaign   ) {
    localStorage.setItem('utmSource',utmSource)
    localStorage.setItem('utmMedium',utmMedium)
    localStorage.setItem('utmCampaign',utmCampaign)

   

   
  }

  }, [])
 
    
console.log(UserType, "usertype")
  return (
    <div className="App">


      <BrowserRouter basename='/classwalidosti'>

      <Switch>

          
            <Route path="/" exact >
              {
                Loading ?<Shimmer /> : 
                
                UserType == 1 ? (<StudentPage/>): UserType == 3 ? (<TutorPage/>) : creativeUrl ? ( <WithCreativeURL/> ):
                
                (
                  // Images.length > 0  ? <Memories Images = {Images} datalength={datalength} getApi={handleGetApi} hasMore={hasMore}/> 
                  <WelcomePage images={Images} datalength={datalength} getApi={handleGetApi} hasMore={hasMore}/>
                )

              }
              </Route> 
             <Route path="/welcomePage" component={WelcomePage} exact/>
      
            
            {/* <Route path="/" component={Memories} exact />
            <Route path="/create" component={WelcomePage} exact/> */}
            <Route path="/details" component={DetailPage} exact />
            <Route path="/output" component={MemoryOutput} exact />
            {/* <Route path="/cardsChain" component={CardsChain} exact /> */}
            {/* <Route exact path="/memory" component={Memories} /> */}
       </Switch>
        </BrowserRouter>

    </div>
  );
}

export default App;
